import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

export const DASHBOARD_SLUGS = {
  BILL_AUTOMATION: {
    PREVIEW: NESTED_ROUTES.BILL_AUTOMATION.PREVIEW,
    SUMMARY: NESTED_ROUTES.BILL_AUTOMATION.SUMMARY,
  },
  COST: {
    ALL_UTILITIES: NESTED_ROUTES.COST.ALL_UTILITIES,
    BUDGETS_ACTUALS: NESTED_ROUTES.COST.BUDGETS_ACTUALS,
    BUDGET_REVIEW: NESTED_ROUTES.COST.BUDGET_REVIEW,
    LINE_ITEM_COST: NESTED_ROUTES.COST.LINE_ITEM_COST,
    UNIT_ECONOMICS: NESTED_ROUTES.COST.UNIT_ECONOMICS,
    WEATHER_NORMALIZED_COST: NESTED_ROUTES.COST.WEATHER_NORMALIZED_COST,
    YEAR_OVER_YEAR: NESTED_ROUTES.COST.YEAR_OVER_YEAR,
    YEAR_OVER_YEAR_BAR: NESTED_ROUTES.COST.YEAR_OVER_YEAR_BAR,
  },
  EV_CHARGING: {
    FACILITY: 'evfacility',
    PREVIEW: 'evpreview',
    SESSION: 'evsession',
    STATION: 'evstation',
  },
  INTERVAL_DATA_ELECTRIC: {
    HEATMAP: 'idelectricheatmap',
    MAP: 'idelectricmap',
    METRICS: 'idelectricmetrics',
    POINTS: 'idelectricpoints',
    PROFILES: 'idelectricprofiles',
    TRENDS: 'idelectrictrends',
    USAGE: 'idelectricusage',
  },
  INTERVAL_DATA_NATURAL_GAS: {
    HEATMAP: 'idnaturalgasheatmap',
    MAP: 'idnaturalgasmap',
    POINTS: 'idnaturalgaspoints',
    USAGE: 'idnaturalgasusage',
  },
  INTERVAL_DATA_PORTFOLIO: {
    ALL_POINTS: 'allpoints',
    METERS: 'idportfoliometers',
    POINTS: 'idportfoliopoints',
    SITES: 'idportfoliosites',
  },
  INTERVAL_DATA_WATER: {
    HEATMAP: 'idwaterheatmap',
    MAP: 'idwatermap',
    POINTS: 'idwaterpoints',
    USAGE: 'idwaterusage',
  },
  REPORTS: {
    ACCOUNT_DETAILS: NESTED_ROUTES.REPORTS.ACCOUNT_DETAILS,
    CALENDAR_NORMALIZED: NESTED_ROUTES.REPORTS.CALENDAR_NORMALIZED,
    FACILITIES: NESTED_ROUTES.REPORTS.FACILITIES,
    HISTORICAL_USAGE_COST: NESTED_ROUTES.REPORTS.HISTORICAL_USAGE_COST,
    LINE_ITEMS: 'reportlineitems',
    TOTAL_ENERGY_COSTS: 'totalenergycosts',
  },
  SMART_METERS: {
    BASELINES: 'smartmeterbaselines',
    HOURLY: 'smartmeterhourly',
    MONTHLY: 'smartmetermonthly',
    PREVIEW: 'smartmeterspreview',
    WEEKLY: 'smartmeterweekly',
  },
  SUMMARY: {
    DATA_COMPLETENESS: NESTED_ROUTES.SUMMARY.DATA_COMPLETENESS,
    DATA_RECENCY: NESTED_ROUTES.SUMMARY.DATA_RECENCY,
    EMISSIONS: NESTED_ROUTES.SUMMARY.EMISSIONS,
    ENERGY_STAR: NESTED_ROUTES.SUMMARY.ENERGY_STAR,
    HOMEPAGE: NESTED_ROUTES.SUMMARY.HOMEPAGE,
    OPPENGINE: NESTED_ROUTES.SUMMARY.OPPENGINE,
  },
  USAGE: {
    ALL_UTILITIES: NESTED_ROUTES.USAGE.ALL_UTILITIES,
    DEMAND: NESTED_ROUTES.USAGE.DEMAND,
    ELECTRIC: NESTED_ROUTES.USAGE.ELECTRIC,
    ENERGY_KBTU: NESTED_ROUTES.USAGE.ENERGY_KBTU,
    GAS: NESTED_ROUTES.USAGE.GAS,
    INVERSE_MODELS: NESTED_ROUTES.USAGE.INVERSE_MODELS,
    PROJECT_SAVINGS: NESTED_ROUTES.USAGE.PROJECT_SAVINGS,
    TEMPERATURE: NESTED_ROUTES.USAGE.TEMPERATURE,
    WATER: NESTED_ROUTES.USAGE.WATER,
    WEATHER: NESTED_ROUTES.USAGE.WEATHER,
    WEATHER_NORMALIZED_USAGE: NESTED_ROUTES.USAGE.WEATHER_NORMALIZED_USAGE,
    YEAR_OVER_YEAR: NESTED_ROUTES.USAGE.YEAR_OVER_YEAR,
    YEAR_OVER_YEAR_BAR: NESTED_ROUTES.USAGE.YEAR_OVER_YEAR_BAR,
  },
};
